import type cytoscape from 'cytoscape'

import type * as models from '../models'

/**
 * Produces {@link cytoscape.ElementsDefinition} from {@link models.Data}
 */
export function getElements({
  nodes,
  edges,
}: models.Data): cytoscape.ElementsDefinition {
  return {
    edges: edges.map(edge => ({
      data: getEdgeDataDefinition(edge),
      group: 'edges',
    })),
    nodes: nodes.map(node => ({
      data: getNodeDataDefinition(node),
      group: 'nodes',
    })),
  }
}

/**
 * Converts a {@link models.Edge} into a {@link cytoscape.EdgeDataDefinition}
 */
export function getEdgeDataDefinition({
  childId,
  parentId,
}: models.Edge): cytoscape.EdgeDataDefinition {
  return {
    id: `${parentId}->${childId}`,
    source: parentId,
    target: childId,
  }
}

/**
 * Converts a {@link models.Node} into a {@link cytoscape.NodeDataDefinition}
 */
export function getNodeDataDefinition(
  node: models.Node,
): cytoscape.NodeDataDefinition {
  // NOTE: we need to at least create a shallow copy since properties may get
  // overwritten in Cytoscape
  return { ...node }
}
